import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { ProgressSpinner } from 'primereact/progressspinner'
import Info from '../info'
import styles from '../../../css/generals/CardsInfo.module.css'
import { useTranslation } from 'react-i18next'

export default function CardsInfo ({ device, infoCards, role, socketReceiveActionsCompleted, realTime, setFlagReload, onHide }) {
  const { t } = useTranslation('dashboardDevice')

  useEffect(() => {
    if (realTime) {
      socketReceiveActionsCompleted(setFlagReload)
    }
  }, [realTime])

  return (
        <div>
            {device === undefined
              ? (<div className={styles.flexContainer}>
                    <ProgressSpinner />
                </div>)
              : device?.error
                ? (<div className={styles.flexContainer}>
                    <h5>{t('cardsInfo.label1')}</h5>
                </div>)
                : (<div className={styles.cardsContainer}>
              {device &&
                infoCards.map((el) => {
                  if (el.compare) {
                    if (Array.isArray(el.key)) {
                      const value = ((device.status_lock === false && device.motive_lock === null))
                        ? t('cardsInfo.label2')
                        : (device.status_lock === false && device.motive_lock === 'locked')
                            ? t('cardsInfo.label3')
                            : (device.status_lock === true && device.motive_lock === 'locked')
                                ? t('cardsInfo.label4')
                                : (device.status_lock === true && device.motive_lock === null)
                                    ? t('cardsInfo.label5')
                                    : (device.status_lock === false && device.motive_lock === 'disabled')
                                        ? t('cardsInfo.label6')
                                        : (device.status_lock === true && device.motive_lock === 'disabled')
                                            ? t('cardsInfo.label7')
                                            : (device.motive_lock === 'activated')
                                                ? t('cardsInfo.label8')
                                                : ''
                      const icon = (value === t('cardsInfo.label4') || value === t('cardsInfo.label7')) ? el.icon[0] : value === t('cardsInfo.label2') ? el.icon[1] : el.icon[2]
                      const key = 'statusLock'
                      return (
                        <Info
                          key={key}
                          title={el.title}
                          value={value}
                          icon={icon}
                          className={`${styles.boxChart}`}
                        />
                      )
                    } else {
                      let text
                      let icon
                      let btn
                      if (el.key === 'so') {
                        text = device?.so
                        icon = device?.so?.includes('Android') ? el.icon[0] : el.icon[1]
                        const textArray = text?.split('_-_')
                        text = textArray[0] + ' ' + textArray[1]
                      }
                      if (el.key === 'model') {
                        text = device?.model
                        icon = el?.icon[0]
                        const textArray = text?.split('_-_')
                        text = textArray[0] + ' ' + textArray[1]
                      }
                      if (el.key === 'codeEstablishment') {
                        text = device?.establishment !== null ? `${device?.establishment?.code} - ${device?.establishment?.name}` : t('cardsInfo.label19')
                        icon = el?.icon[0]
                        btn = device?.establishment === null && role?.actionEstablishment ? t('cardsInfo.label17') : undefined
                      }
                      if (el.key === 'addressEstablishment') {
                        text = device?.establishment !== null ? `${device?.establishment?.address}, ${device?.establishment?.district}` : t('cardsInfo.label19')
                        icon = el?.icon[0]
                        btn = device?.establishment !== null && role?.actionEstablishment ? t('cardsInfo.label18') : undefined
                      }

                      return (
                            <Info
                              key={el.key}
                              title={el.title}
                              value={text}
                              icon={icon}
                              className={`${styles.boxChart}`}
                              btn={btn}
                              click={() => onHide()}
                            />
                      )
                    }
                  } else {
                    return (
                      <Info
                        key={el.key}
                        title={el.title}
                        value={device[el.key]}
                        icon={el.icon[0]}
                        className={`${styles.boxChart}`}
                      />
                    )
                  }
                })}
                </div>)
            }
        </div>
  )
}

CardsInfo.propTypes = {
  device: PropTypes.object,
  infoCards: PropTypes.array,
  role: PropTypes.object,
  socketReceiveActionsCompleted: PropTypes.function,
  realTime: PropTypes.bool,
  setFlagReload: PropTypes.func,
  onHide: PropTypes.func
}
